import { Route } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { AdminRoutes } from './routes/admin.routes';
import { ComponentsRoutes } from './routes/components.routes';
import { CustomerRoutes } from './routes/customer.routes';
import { I18nRoutes } from './routes/i18n.routes';
import { PostRoutes } from './routes/post.routes';
import { ShopRoutes } from './routes/shop.routes';
import { SiteRoutes } from './routes/site.routes';
import { StatisticsRoutes } from './routes/stat.routes';
import { UserRoutes } from './routes/user.routes';

export const appRoutes: Route[] = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/auth/sign-in/sign-in.page'),
  },
  // {
  //   path: 'sign-up',
  //   loadComponent: () => import('./pages/auth/sign-up/sign-up.page'),
  // },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'admin',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        redirectTo: 'admin',
        pathMatch: 'full',
      },
      ...UserRoutes,
      ...AdminRoutes,
      ...CustomerRoutes,
      ...SiteRoutes,
      ...PostRoutes,
      ...I18nRoutes,
      {
        path: 'my-page',
        loadComponent: () => import('./pages/my-page/my-page.page'),
      },
      ...StatisticsRoutes,
      ...ComponentsRoutes,
      {
        path: '**',
        redirectTo: 'admin',
      },
    ],
  },
  ...ShopRoutes,
];
